import { z } from "zod";

// Schema
export const urlSchema = z.object({
  label: z.string(),
  href: z
    .string()
    .describe("leave start with https:// if provided, if not provided, leave ''")
    .default(""),
});

// Type
export type URL = z.infer<typeof urlSchema>;

// Defaults
export const defaultUrl: URL = {
  label: "",
  href: "",
};
